import Button from "devextreme-react/button";
import { useContext } from "react";
import { LoadPagePanel } from "../../../../components";
import { AR } from "../../../../types/enums";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { useDealerDates } from "../api/update-dealer-dates";
import { RetailOrderContext } from "../context/RetailOrderContext";
import { UpdateDealerDatesParams } from "../types/UpdateDealerDatesParams";

export default function SaveChangesButton() {

    const { order, refetchOrder } = useContext(RetailOrderContext);

    const updateParams = { retailOrderID: order.details.retailOrderID } as UpdateDealerDatesParams;

    if (order.details.activeARs.includes(AR.DealerToEnterEstimatedCabinetDeliveryDate) ||
        (order.details.resolvedARs.includes(AR.DealerToEnterEstimatedCabinetDeliveryDate) &&
            !order.details.resolvedARs.includes(AR.DealerToEnterCabinetPOReceivedDate))) {
        updateParams.estimatedCabinetDeliveryDate = order.details.estimatedCabinetDeliveryDate;
        updateParams.setEstimatedCabinetDeliveryDate = true;
    }

    if (order.details.activeARs.includes(AR.DealerToEnterEstimatedCabinetDeliveryDate) ||
        (order.details.resolvedARs.includes(AR.DealerToEnterEstimatedCabinetDeliveryDate) &&
            !order.details.resolvedARs.includes(AR.DealerToEnterCabinetPOReceivedDate))) {
        updateParams.cabinetShipDate = order.details.cabinetShipDate;
        updateParams.carrierName = order.details.carrierName;
        updateParams.trackingNumber = order.details.trackingNumber;
        updateParams.setShipInfo = true;
    }

    if (order.details.activeARs.includes(AR.DealerToEnterCabinetPOReceivedDate)) {
        updateParams.cabinetPOReceivedDate = order.details.cabinetPOReceivedDate;
        updateParams.setCabinetPOReceivedDate = true;
    }

    const updateRetailOrder = useDealerDates(updateParams,
        () => {
            showSuccessMessage('Retail order has been updated');
            refetchOrder();
        },
        (error: string) => showErrorMessage(error)
    );


    return (
        <>
            <Button
                text="Save Changes"
                icon="Inscyth-Save"
                elementAttr={{ 'data-testid': 'btn-save' }}
                visible={!order.details.activeARs.includes(AR.DealerToConfirmChangeOrder) &&
                    (order.details.activeARs.includes(AR.DealerToEnterEstimatedCabinetDeliveryDate) ||
                        order.details.activeARs.includes(AR.DealerToEnterCabinetShipDate) ||
                        order.details.activeARs.includes(AR.DealerToEnterCabinetPOReceivedDate) ||
                        (order.details.resolvedARs.includes(AR.DealerToEnterEstimatedCabinetDeliveryDate) &&
                            !order.details.resolvedARs.includes(AR.DealerToEnterCabinetPOReceivedDate)) ||
                        (order.details.resolvedARs.includes(AR.DealerToEnterCabinetShipDate) &&
                            !order.details.resolvedARs.includes(AR.DealerToEnterCabinetPOReceivedDate)))}
                disabled={!order.modified || updateRetailOrder.isLoading}
                onClick={(e) => {
                    let result = e.validationGroup.validate();
                    if (result.isValid) {
                        updateRetailOrder.mutate();
                    }
                }}>
            </Button>
            <LoadPagePanel visible={updateRetailOrder.isLoading} />
        </>
    )
}